import React from 'react';
import { Route, IndexRoute } from 'react-router';
import FinancialDashboard from './FinancialDashboard';

export default (
  <Route path="acompanhar-venda">
    <IndexRoute component={(props) => <FinancialDashboard {...props} />} />
  </Route>
);
